(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ri-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('[data-ri-main-image]');
      gallery.querySelectorAll('[data-ri-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!main) return;
          main.src = thumb.dataset.src;
          main.srcset = '';
          main.alt = thumb.dataset.alt || main.alt;
          gallery.querySelectorAll('[data-ri-thumb]').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    });

    root.querySelectorAll('[data-ri-qty]').forEach((quantity) => {
      if (quantity.dataset.ready) return;
      quantity.dataset.ready = 'true';
      const input = quantity.querySelector('input[type="number"]');
      quantity.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => {
          if (!input) return;
          const value = Number(input.value || 1) + Number(button.dataset.step || 0);
          input.value = Math.max(Number(input.min || 1), value);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    root.querySelectorAll('[data-ri-product-form],.ri-ajax-cart-form').forEach((form) => {
      if (form.dataset.variantReady) return;
      form.dataset.variantReady = 'true';
      const data = form.querySelector('[data-ri-variants]');
      const idInput = form.querySelector('input[name="id"]');
      const submitButtons = form.querySelectorAll('button[type="submit"]');
      const price = form.closest('.ri-info')?.querySelector('[data-ri-price]');
      const pricing = form.closest('.ri-info')?.querySelector('[data-ri-pricing]');
      const comparePrice = pricing?.querySelector('[data-ri-compare-price]');
      const priceMeta = pricing?.querySelector('[data-ri-price-meta]');
      const discountBadge = pricing?.querySelector('[data-ri-discount-badge]');
      const stock = form.querySelector('[data-ri-stock]');
      const galleryImage = document.querySelector('[data-ri-main-image]');
      let variants = [];
      try { variants = JSON.parse(data?.textContent || '[]'); } catch (error) { variants = []; }
      const syncVariant = () => {
        const selected = [...form.querySelectorAll('[data-ri-option]')].map((option) => option.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant || !idInput) return;
        idInput.value = variant.id;
        submitButtons.forEach((button) => { button.disabled = !variant.available; });
        if (stock) {
          stock.classList.toggle('is-out', !variant.available);
          const label = stock.querySelector('span');
          if (label) label.textContent = variant.available ? stock.dataset.inText : 'المنتج غير متوفر حاليًا';
        }
        const variantImage = variant.featured_media?.preview_image?.src;
        if (galleryImage && variantImage) { galleryImage.src = variantImage; galleryImage.srcset = ''; }
        if (price) {
          const currency = form.querySelector('[data-ri-currency]')?.dataset.riCurrency || 'EGP';
          const formatMoney = (value) => { try { return new Intl.NumberFormat(document.documentElement.lang || 'ar-EG', { style: 'currency', currency }).format(value / 100); } catch (error) { return (value / 100).toFixed(2); } };
          try { price.textContent = formatMoney(variant.price); }
          catch (error) { price.textContent = (variant.price / 100).toFixed(2); }
          if (pricing && priceMeta) {
            const configuredCompare = pricing.dataset.compareSource === 'manual' ? Number(pricing.dataset.manualCompare || 0) : Number(variant.compare_at_price || 0);
            const hasDiscount = pricing.dataset.showCompare === 'true' && configuredCompare > Number(variant.price);
            priceMeta.hidden = !hasDiscount;
            if (hasDiscount && comparePrice) comparePrice.textContent = formatMoney(configuredCompare);
            if (hasDiscount && discountBadge && pricing.dataset.showDiscount === 'true') {
              const saving = configuredCompare - Number(variant.price);
              const calculated = pricing.dataset.discountFormat === 'money' ? `وفّر ${formatMoney(saving)}` : `خصم ${Math.round((saving / configuredCompare) * 100)}%`;
              const manual = pricing.dataset.discountFormat === 'money' ? `خصم ${formatMoney(Number(pricing.dataset.manualDiscount || 0) * 100)}` : `خصم ${Number(pricing.dataset.manualDiscount || 0)}%`;
              discountBadge.textContent = pricing.dataset.discountSource === 'manual' ? manual : calculated;
            }
          }
        }
      };
      form.querySelectorAll('[data-ri-option]').forEach((option) => option.addEventListener('change', syncVariant));
      form.addEventListener('submit', async (event) => {
        if (event.submitter?.name === 'checkout') return;
        event.preventDefault();
        const button = event.submitter || form.querySelector('.ri-atc');
        if (!button) return;
        button.disabled = true;
        button.classList.add('is-loading');
        try {
          const payload = new FormData(form);
          payload.append('sections', 'honey-cart-drawer');
          payload.append('sections_url', window.location.pathname);
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: payload });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'تعذر إضافة المنتج');
          const sectionHtml = result.sections?.['honey-cart-drawer'];
          if (sectionHtml) window.HoneyCart?.replace(sectionHtml);
          else await window.HoneyCart?.refresh(false);
          window.HoneyCart?.open();
        } catch (error) {
          window.HoneyCart?.showError(error.message || 'تعذر إضافة المنتج. حاول مرة أخرى.');
        } finally {
          button.disabled = false;
          button.classList.remove('is-loading');
        }
      });
    });
  };

  const initUpsellCarousels = (scope = document) => {
    scope.querySelectorAll('[data-hc-upsell-slider]').forEach((slider) => {
      if (slider.dataset.sliderReady || slider.dataset.carousel !== 'true') return;
      slider.dataset.sliderReady = 'true';
      const track = slider.querySelector('.hc-upsell__track');
      const cards = [...slider.querySelectorAll('.hc-upsell__card')];
      if (!track || cards.length < 2 || slider.dataset.autoplay !== 'true') return;
      let index = 0;
      let paused = false;
      const move = () => {
        if (paused || !slider.isConnected || document.hidden) return;
        index = (index + 1) % cards.length;
        const target = cards[index];
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };
      const timer = window.setInterval(move, Math.max(2000, Number(slider.dataset.speed || 4000)));
      slider.dataset.timerId = String(timer);
      if (slider.dataset.pauseHover === 'true') {
        slider.addEventListener('mouseenter', () => { paused = true; });
        slider.addEventListener('mouseleave', () => { paused = false; });
      }
      track.addEventListener('pointerdown', () => { paused = true; }, { passive: true });
      track.addEventListener('pointerup', () => { paused = false; }, { passive: true });
    });
  };

  const localizeHeader = (scope = document) => {
    scope.querySelectorAll('header input[type="search"],header input[name="q"],.t4s-search-header input').forEach((input) => { input.placeholder = 'ابحث عن المنتجات'; input.setAttribute('aria-label', 'ابحث عن المنتجات'); });
    [['header a[href*="/cart"]','سلة التسوق'],['header a[href*="/account"]','حسابي'],['header a[href*="wishlist"]','قائمة الرغبات'],['header a[href*="/search"]','البحث']].forEach(([selector,label]) => scope.querySelectorAll(selector).forEach((item) => { item.setAttribute('aria-label', label); item.setAttribute('title', label); }));
    scope.querySelectorAll('header .t4s-site-nav__btnMenu,header [data-menu-drawer]').forEach((item) => { item.setAttribute('aria-label', 'فتح القائمة'); item.setAttribute('title', 'القائمة'); });
    scope.querySelectorAll('[aria-label="Close menu, categories"]').forEach((item) => item.setAttribute('aria-label', 'إغلاق القائمة والفئات'));
  };

  const syncMobileToolbarOffset = () => {
    const toolbar = document.querySelector('.t4s-toolbar');
    const visible = toolbar && window.getComputedStyle(toolbar).display !== 'none';
    const height = visible ? Math.ceil(toolbar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--honey-mobile-toolbar-offset', `${height}px`);
  };

  const initProductUpsells = (scope = document) => {
    scope.querySelectorAll('[data-ri-upsell-slider]').forEach((slider) => {
      if (slider.dataset.sliderReady || slider.dataset.carousel !== 'true') return;
      slider.dataset.sliderReady = 'true'; const track = slider.querySelector('.ri-purchase-upsell__track'); const cards = [...slider.querySelectorAll('.ri-purchase-upsell__card')];
      if (!track || cards.length < 2 || slider.dataset.autoplay !== 'true') return;
      let index = 0; window.setInterval(() => { if (!slider.isConnected || document.hidden) return; index = (index + 1) % cards.length; track.scrollTo({ left: cards[index].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }, Math.max(2000, Number(slider.dataset.speed || 4000)));
    });
  };

  const syncExternalBuyApp = () => {
    document.querySelectorAll('[data-arc-comparison]').forEach((section) => { section.querySelectorAll('.arc-ring').forEach((ring) => { const percentage = Math.max(0, Math.min(100, Number.parseFloat(ring.querySelector('span')?.textContent || 0))); const circle = ring.querySelector('.arc-prog'); if (circle) circle.style.strokeDashoffset = String(163.362 - (percentage * 1.63362)); }); section.classList.add('is-visible'); });
    const appSelector = [
      '[id*="easysell" i]', '[class*="easysell" i]', '[data-app*="easysell" i]',
      '[id*="easy-sell" i]', '[class*="easy-sell" i]', '[id*="cod-form" i]',
      '[class*="cod-form" i]', 'iframe[src*="easysell" i]', 'form[action*="easysell" i]',
      '.ri-app-block--purchase .shopify-app-block'
    ].join(',');
    const assetSelector = [
      'script[src*="easysell" i]', 'script[src*="easysell-cod-form" i]',
      'link[href*="easysell" i]', 'iframe[src*="easysell" i]'
    ].join(',');
    const orderEnabled = document.body?.dataset.honeyOrderEnabled !== 'false';
    const showNativeEasySell = document.body?.dataset.honeyShowNativeEasysell === 'true';
    const orderText = document.body?.dataset.honeyOrderText || 'اضغط هنا للطلب';
    const orderIcon = document.body?.dataset.honeyOrderIcon || '';
    const orderMode = document.body?.dataset.honeyOrderMode || 'easysell';
    if (!orderEnabled) document.querySelectorAll('.honey-card-easyorder').forEach((item) => item.remove());
    const easySellButtons = [...document.querySelectorAll('.ri-info .es-popup-button,#es-popup-button')].filter((item, index, list) => list.indexOf(item) === index);
    const isEasySellActive = document.documentElement.classList.contains('honey-easysell-active') || Boolean(document.querySelector(assetSelector)) || easySellButtons.length > 0;
    const raw = [...document.querySelectorAll(appSelector)];
    const containers = raw.map((item) => item.closest('.shopify-app-block') || item.closest('[data-shopify-editor-block]') || item).filter((item, index, list) => item && list.indexOf(item) === index);
    const topLevel = containers.filter((item) => !containers.some((other) => other !== item && other.contains(item)));
    if (!isEasySellActive && !topLevel.length && !orderEnabled) return;
    if (isEasySellActive || topLevel.length) document.documentElement.classList.add('honey-easysell-active');
    if (!document.body.classList.contains('template-product')) {
      if (isEasySellActive && !showNativeEasySell) document.querySelectorAll('.es-popup-button,#es-popup-button,.es-sticky-btn').forEach((item) => { item.hidden = true; item.style.setProperty('display', 'none', 'important'); });
      if (orderEnabled) document.querySelectorAll('.hh-card,.cg-card').forEach((card) => {
        if (card.querySelector('.honey-card-easyorder')) return;
        const productLink = card.querySelector('.hh-card__title,.cg-card__title,.hh-card__image,.cg-card__media');
        const actions = card.querySelector('.hh-card__actions,.cg-actions') || card.querySelector('.hh-card__body,.cg-card__body');
        if (!productLink?.href || !actions) return;
        const orderLink = document.createElement('a'); orderLink.className = 'honey-card-easyorder'; orderLink.href = productLink.href; orderLink.textContent = orderText; orderLink.dataset.orderIcon = orderIcon; orderLink.dataset.orderMode = orderMode; orderLink.setAttribute('aria-label', `اطلب ${card.querySelector('.hh-card__title,.cg-card__title')?.textContent?.trim() || 'المنتج'}`); actions.append(orderLink);
      });
    }
    if (orderEnabled) document.querySelectorAll('.t4s-pr-grid,.t4s-product2,.hh-card,.cg-card,.hpr-card').forEach((card) => {
      if (card.querySelector('.honey-card-easyorder')) return;
      const productLink = [...card.querySelectorAll('a[href*="/products/"]')].find((link) => !link.closest('.honey-card-easyorder'));
      if (!productLink?.href) return;
      const actions = card.querySelector('.t4s-product-info__btns,.t4s-product-info__inner,.hh-card__actions,.cg-actions,.hpr-body,.ri-purchase-upsell__card>div') || card;
      const orderLink = document.createElement('a'); orderLink.className = 'honey-card-easyorder'; orderLink.href = productLink.href; orderLink.textContent = orderText; orderLink.dataset.orderIcon = orderIcon; orderLink.dataset.orderMode = orderMode; orderLink.setAttribute('aria-label', 'فتح الطلب بالطريقة المختارة'); actions.append(orderLink);
    });
    if (isEasySellActive) document.querySelectorAll('[data-ri-native-purchase]').forEach((item) => { item.hidden = true; item.style.display = 'none'; });
    if (easySellButtons.length) {
      const preferredButton = easySellButtons.find((item) => item.classList.contains('es-popup-button-product') && !item.closest('.ri-buyrow')) || easySellButtons.find((item) => !item.closest('.ri-buyrow')) || easySellButtons[0];
      easySellButtons.forEach((item) => {
        const keep = showNativeEasySell && item === preferredButton;
        item.hidden = !keep;
        item.style.setProperty('display', keep ? 'flex' : 'none', 'important');
        item.toggleAttribute('data-ri-duplicate-app', !keep);
      });
    }
    topLevel.forEach((item, index) => {
      if (index === 0) { item.hidden = false; item.style.removeProperty('display'); }
      else { item.hidden = true; item.style.display = 'none'; item.setAttribute('data-ri-duplicate-app', 'true'); }
    });
  };
  document.addEventListener('click', (event) => { const button = event.target.closest('[data-hpt-tab]'); if (!button) return; const tabs = button.closest('[data-hpt-tabs]'); tabs.querySelectorAll('[data-hpt-tab]').forEach((item) => item.classList.toggle('is-active', item === button)); tabs.querySelectorAll('[data-hpt-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.hptPanel === button.dataset.hptTab)); });
  let appSyncQueued = false;
  const queueAppSync = () => { if (appSyncQueued) return; appSyncQueued = true; requestAnimationFrame(() => { appSyncQueued = false; syncExternalBuyApp(); }); };
  new MutationObserver(queueAppSync).observe(document.documentElement, { childList: true, subtree: true });

  const cart = {
    root: () => document.querySelector('#HoneyCartDrawer'),
    open() { const root = this.root(); if (!root) return; root.classList.add('is-open'); document.documentElement.classList.add('hc-lock'); root.querySelector('.hc-drawer')?.focus(); },
    close() { this.root()?.classList.remove('is-open'); document.documentElement.classList.remove('hc-lock'); },
    replace(html) { const doc = new DOMParser().parseFromString(html, 'text/html'); const next = doc.querySelector('#HoneyCartDrawer'); const current = this.root(); if (next && current) { const wasOpen = current.classList.contains('is-open'); const bodyScroll = current.querySelector('.hc-body')?.scrollTop || 0; if (wasOpen) next.classList.add('is-open'); current.replaceWith(next); const nextBody = next.querySelector('.hc-body'); if (nextBody) nextBody.scrollTop = bodyScroll; if (wasOpen) document.documentElement.classList.add('hc-lock'); initUpsellCarousels(next); } },
    showError(message) { const root = this.root(); if (!root) return; const toast = root.querySelector('[data-hc-toast]'); if (toast) { toast.textContent = message; toast.hidden = false; } this.open(); },
    updateCount(count) { document.querySelectorAll('.t4s-cart-count,.t4s-count-box,[data-cart-count]').forEach((item) => { item.textContent = count; item.dataset.count = count; }); },
    async refresh(openAfter = false, allowGift = true) {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=honey-cart-drawer`, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const html = await response.text();
      this.replace(html);
      const state = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((item) => item.json());
      this.updateCount(state.item_count);
      if (allowGift) await this.maybeAddGift(state);
      if (openAfter) this.open();
    },
    async maybeAddGift(state) {
      const root = this.root();
      if (!root || root.dataset.autoGift !== 'true') return;
      const variantId = Number(root.dataset.giftVariant || 0);
      const threshold = Number(root.dataset.giftThreshold || 0);
      if (!variantId || state.total_price < threshold || state.items.some((item) => item.variant_id === variantId)) return;
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_هدية مجانية': 'نعم' } }] }) });
      await this.refresh(true, false);
    },
    async change(key, quantity) {
      const nextQuantity = Math.max(0, Number(quantity));
      const item = [...(this.root()?.querySelectorAll('[data-hc-item]') || [])].find((row) => row.dataset.key === key);
      if (item) { item.classList.add('is-updating'); const value = item.querySelector('.hc-item__controls span'); if (value && nextQuantity > 0) value.textContent = nextQuantity; }
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: nextQuantity }) });
        if (!response.ok) throw new Error('تعذر تحديث السلة');
        await this.refresh(false);
      } catch (error) { if (item) item.classList.remove('is-updating'); this.showError(error.message); }
    },
    async addUpsell(id, button) {
      button.disabled = true;
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
      await this.refresh(true);
    }
  };
  window.HoneyCart = cart;

  const resolveOrderVariant = async (card, productUrl) => {
    const direct = card?.querySelector('input[name="id"]')?.value || card?.dataset.variantId;
    if (direct) return Number(direct);
    if (!productUrl) return 0;
    const url = new URL(productUrl, window.location.origin);
    url.search = '';
    url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
    const product = await fetch(url.toString(), { headers: { Accept: 'application/json' } }).then((response) => response.ok ? response.json() : null);
    return Number(product?.variants?.find((variant) => variant.available)?.id || product?.variants?.[0]?.id || 0);
  };
  const addOrderProduct = async (card, productUrl) => {
    const variantId = await resolveOrderVariant(card, productUrl);
    if (!variantId) throw new Error('تعذر تحديد المنتج');
    const quantity = Math.max(1, Number(card?.querySelector('input[name="quantity"]')?.value || 1));
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity }] }) });
    if (!response.ok) throw new Error('تعذر إضافة المنتج');
    const state = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((item) => item.json());
    cart.updateCount(state.item_count);
    return state;
  };

  if (document.querySelector('#HoneyCartDrawer')) document.documentElement.classList.add('honey-custom-cart-active');
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a[href$="/cart"],a[href="/cart"],[data-open-cart],[data-cart-link]');
    if (!trigger || !document.querySelector('#HoneyCartDrawer')) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    cart.open();
  }, true);

  document.addEventListener('click', (event) => {
    const nativeOrderButton = event.target.closest('[data-product-order],.hh-card__buy,.cg-buy,.ri-buy,button[name="checkout"]');
    const nativeOrderMode = nativeOrderButton?.dataset.orderMode || document.body.dataset.honeyOrderMode || 'easysell';
    const shouldHandleNativeOrder = nativeOrderButton && (nativeOrderMode === 'easysell' || (nativeOrderButton.hasAttribute('data-product-order') && nativeOrderMode === 'checkout'));
    if (shouldHandleNativeOrder && !nativeOrderButton.matches('.es-popup-button,.es-popup-button-product,#es-popup-button,.es-sticky-btn')) {
      event.preventDefault();
      event.stopPropagation();
      const card = nativeOrderButton.closest('.t4s-pr-grid,.t4s-product2,.hh-card,.cg-card,.hpr-card,.ri-info');
      let appButton = null;
      if (nativeOrderMode === 'easysell') try {
        const selector = document.body.dataset.honeyOrderSelector || '#es-popup-button,.es-popup-button-product,.es-popup-button,.es-sticky-btn';
        appButton = card?.querySelector(selector) || [...document.querySelectorAll(selector)].find((item) => !item.hasAttribute('data-ri-duplicate-app')) || document.querySelector(selector);
      } catch (error) { appButton = null; }
      const productLink = card?.querySelector('a[href*="/products/"]');
      const productUrl = productLink?.href || (document.body.classList.contains('template-product') ? window.location.href : '');
      nativeOrderButton.classList.add('is-loading');
      addOrderProduct(card, productUrl).then(() => { nativeOrderButton.classList.remove('is-loading'); if (nativeOrderMode === 'checkout') window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`); else if (appButton && appButton !== nativeOrderButton) appButton.click(); else if (productUrl) window.location.assign(productUrl); }).catch(() => { nativeOrderButton.classList.remove('is-loading'); if (productUrl) window.location.assign(productUrl); });
      return;
    }
    const orderButton = event.target.closest('.honey-card-easyorder');
    if (orderButton && orderButton.dataset.orderMode !== 'product') {
      event.preventDefault();
      const mode = orderButton.dataset.orderMode || document.body.dataset.honeyOrderMode || 'easysell';
      const card = orderButton.closest('.t4s-pr-grid,.t4s-product2,.hh-card,.cg-card,.hpr-card');
      if (mode === 'easysell') {
        let appButton = null;
        try {
          const selector = document.body.dataset.honeyOrderSelector || '#es-popup-button,.es-popup-button-product,.es-popup-button,.es-sticky-btn';
          appButton = card?.querySelector(selector) || [...document.querySelectorAll(selector)].find((item) => !item.hasAttribute('data-ri-duplicate-app')) || document.querySelector(selector);
        } catch (error) { appButton = null; }
        orderButton.classList.add('is-loading');
        addOrderProduct(card, orderButton.href).then(() => { orderButton.classList.remove('is-loading'); if (appButton && appButton !== orderButton) appButton.click(); else window.location.assign(orderButton.href); }).catch(() => { orderButton.classList.remove('is-loading'); window.location.assign(orderButton.href); });
        return;
      }
      if (mode === 'checkout') {
        orderButton.classList.add('is-loading');
        addOrderProduct(card, orderButton.href)
          .then(() => window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`))
          .catch(() => { orderButton.classList.remove('is-loading'); window.location.assign(orderButton.href); });
        return;
      }
    }
    const checkout = event.target.closest('[data-hc-checkout]');
    if (checkout && checkout.dataset.checkoutMode === 'easysell') {
      event.preventDefault();
      let appButton = null;
      try {
        const selector = checkout.dataset.easysellSelector || '#es-popup-button,.es-popup-button-product,.es-popup-button,.es-sticky-btn';
        const matches = [...document.querySelectorAll(selector)].filter((item) => item !== checkout);
        appButton = matches.find((item) => !item.hasAttribute('data-ri-duplicate-app')) || matches[0];
      } catch (error) { appButton = null; }
      if (appButton) {
        cart.close();
        window.setTimeout(() => appButton.click(), 80);
      } else if (checkout.dataset.easysellFallback === 'true') {
        window.location.assign(checkout.href);
      } else {
        cart.showError('تعذر فتح نموذج EasySell. تأكد من تفعيل التطبيق أو محدد الزر من إعدادات السلة.');
      }
      return;
    }
    const close = event.target.closest('[data-hc-close]');
    if (close) { cart.close(); return; }
    const upsellNotice = event.target.closest('[data-hc-scroll-upsell]');
    if (upsellNotice) { cart.root()?.querySelector('.hc-upsell')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    const quantity = event.target.closest('[data-hc-qty]');
    if (quantity) { const item = quantity.closest('[data-hc-item]'); if (item) cart.change(item.dataset.key, quantity.dataset.hcQty); return; }
    const upsell = event.target.closest('[data-hc-upsell]');
    if (upsell) { cart.addUpsell(upsell.dataset.hcUpsell, upsell); return; }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') cart.close(); });
  document.querySelectorAll('header a[href$="/cart"],header a[href="/cart"],[data-cart-link]').forEach((link) => { link.setAttribute('aria-label', 'فتح سلة التسوق'); link.setAttribute('title', 'سلة التسوق'); link.classList.add('honey-header-cart'); });

  document.addEventListener('DOMContentLoaded', () => { init(); initUpsellCarousels(); initProductUpsells(); localizeHeader(); syncExternalBuyApp(); syncMobileToolbarOffset(); });
  window.addEventListener('resize', syncMobileToolbarOffset, { passive: true });
  document.addEventListener('shopify:section:load', (event) => { init(event.target); initProductUpsells(event.target); localizeHeader(event.target); });
})();
